module.exports = __webpack_public_path__ + "img/parking.ca7bdf16.svg";